import _Input from "@material-ui/core/esm/Input";
import _Slider from "@material-ui/core/esm/Slider";
import _debounce from "lodash/debounce";
import _isFinite from "lodash/isFinite";
import _isString from "lodash/isString";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CSSclasses from './price-range.scss';
import { useStyles } from './slider-settings';
const LEFT = 0;
const RIGHT = 1;
const inputProps = {
  type: 'text'
};
class PriceRange extends React.Component {
  constructor(props) {
    super(props);
    // @todo. auto generated. fix this error
    // @ts-ignore
    _defineProperty(this, "debouncedValidateInputAndPerformAction", void 0);
    _defineProperty(this, "handleSliderChange", (event, value) => {
      const {
        onChange
      } = this.props;
      onChange(value);
    });
    _defineProperty(this, "isValidInputValue", value => {
      if (_isString(value) && value.length === 0) {
        return true;
      }
      return value ? _isFinite(+value) : false;
    });
    _defineProperty(this, "handleInputChange", (event, index) => {
      const {
        value
      } = event.target;
      if (!this.isValidInputValue(value)) {
        return null;
      }
      this.setState({
        stateInputs: this.state.stateInputs.map((inputValue, inputIndex) => index === inputIndex ? value : inputValue)
      });
      this.debouncedValidateInputAndPerformAction(_objectSpread({}, event), index);
    });
    _defineProperty(this, "validateInputAndPerformAction", (event, index) => {
      const {
        filterData,
        selectedFilter = [],
        onChange
      } = this.props;
      const [{
        data: min
      }, {
        data: max
      }] = filterData;
      const {
        value
      } = event.target;
      const [left = min, right = max] = selectedFilter;
      let number = Number(value);
      if (!number) {
        // @todo. auto generated. fix this error
        // @ts-ignore
        this.setState({
          stateInputs: [null, null]
        });
        return null;
      }
      const nextRange = [left, right];
      if (number > max) {
        number = max;
      }
      if (number < min) {
        number = min;
      }
      if (index === LEFT) {
        if (number >= nextRange[RIGHT]) {
          number = nextRange[RIGHT] - 1;
        }
      }
      if (index === RIGHT) {
        if (number <= nextRange[LEFT]) {
          number = nextRange[LEFT] + 1;
        }
      }
      nextRange[index] = number;

      // @todo. auto generated. fix this error
      // @ts-ignore
      this.setState({
        stateInputs: [null, null]
      });
      onChange(nextRange);
    });
    this.state = {
      stateInputs: [null, null]
    };

    // @todo. auto generated. fix this error
    // @ts-ignore
    this.debouncedValidateInputAndPerformAction = _debounce(this.validateInputAndPerformAction, 2000);
  }
  render() {
    const {
      classes,
      filterData,
      isDisabled,
      selectedFilter = [],
      color
    } = this.props;
    const [{
      data: min
    }, {
      data: max
    }] = filterData;
    const [left = min, right = max] = selectedFilter;
    const [leftInput, rightInput] = this.state.stateInputs;
    const sliderClasses = {
      track: classes.track,
      rail: classes.rail,
      thumb: classnames(classes.thumb, CSSclasses.thumb)
    };
    return /*#__PURE__*/React.createElement("div", {
      "data-block": "PriceFilter"
    }, /*#__PURE__*/React.createElement(_Slider, {
      color: 'secondary',
      min: min,
      max: max,
      value: [left, right],
      step: 1,
      onChange: this.handleSliderChange,
      disabled: isDisabled,
      classes: sliderClasses
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.inputs
    }, /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.bold
    }, /*#__PURE__*/React.createElement("span", null, "$\xA0"), /*#__PURE__*/React.createElement(_Input, {
      "data-input": "MinPrice",
      classes: {
        underline: classes.underline,
        input: classes.input
      },
      className: classes.input,
      value: this.isValidInputValue(leftInput) ? leftInput : left,
      margin: "dense",
      onChange: e => this.handleInputChange(e, LEFT),
      inputProps: _extends(inputProps, {
        style: {
          color
        }
      }),
      disabled: isDisabled
    })), /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.bold
    }, /*#__PURE__*/React.createElement("span", null, "$\xA0"), /*#__PURE__*/React.createElement(_Input, {
      "data-input": "MaxPrice",
      classes: {
        underline: classes.underline,
        input: classes.input
      },
      className: classes.input,
      value: this.isValidInputValue(rightInput) ? rightInput : right,
      margin: "dense",
      onChange: e => this.handleInputChange(e, RIGHT),
      inputProps: _extends(inputProps, {
        style: {
          color
        }
      }),
      disabled: isDisabled
    }))));
  }
}
export default withStyles(useStyles)(PriceRange);